// Module
var code = `<div class="form-horizontal"> <div class="form-group col-sm-12"> <label> <span translate>Gift Card Code</span> <input type="text" ng-model="currentPayment.giftCard.giftCardId" ng-model-options="{ allowInvalid: true }" class="form-control" autocomplete="off" minlength="10" maxlength="12" pattern="[a-zA-Z0-9]+"/> </label> </div> </div> `;
// Exports
var _module_exports =code;;
var path = '/scripts/directives/payment/paymentMethods/giftCard.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;